import { InLoading } from "../components/Animation";
import Layout from "../components/Layout";
export const Loading = () => {
  return (
    <Layout>
        <InLoading />
    </Layout>
  );
};
